export const sizeCheckBig = (file: File, limit: number): boolean => {
  if (file.size > limit) {
    return false;
  }
  return true;
}
